import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IModelDictionaryDatum} from '../../model/dictionaryDatum';
import {IBaseDictionaryState, IChangeIsInitialized, IChangeIsLoading, ISetError} from './workTypeSlice';

export interface ITechnologyToolState extends IBaseDictionaryState {
    technologyTools: IModelDictionaryDatum[] | null;
}

export interface IChangeTechnologyTool {
    technologyTools: IModelDictionaryDatum[] | null;
}

const initialState: ITechnologyToolState = {
    technologyTools: null,
    isLoading: false,
    isInitialized: false,
    error: null,
};

const technologyToolSlice = createSlice({
    name: 'technologyTool',
    initialState: initialState,
    reducers: {
        changeTechnologyTool: {
            reducer: (state: ITechnologyToolState, action: PayloadAction<IChangeTechnologyTool>) => {
                return {
                    technologyTools: action.payload.technologyTools,
                    isLoading: state.isLoading,
                    isInitialized: state.isInitialized,
                    error: state.error,
                };
            },
            prepare(technologyTools: IModelDictionaryDatum[] | null) {
                return {
                    payload: {technologyTools: technologyTools},
                };
            },
        },
        changeIsTechnologyToolLoading: {
            reducer: (state: ITechnologyToolState, action: PayloadAction<IChangeIsLoading>) => {
                return {
                    technologyTools: state.technologyTools,
                    isLoading: action.payload.isLoading,
                    isInitialized: state.isInitialized,
                    error: state.error,
                };
            },
            prepare(isLoading: boolean) {
                return {
                    payload: {isLoading: isLoading},
                };
            },
        },
        changeIsTechnologyToolInitialized: {
            reducer: (state: ITechnologyToolState, action: PayloadAction<IChangeIsInitialized>) => {
                return {
                    technologyTools: state.technologyTools,
                    isLoading: state.isLoading,
                    isInitialized: action.payload.isInitialized,
                    error: state.error,
                };
            },
            prepare(isInitialized: boolean) {
                return {
                    payload: {isInitialized: isInitialized},
                };
            },
        },
        setTechnologyToolError: {
            reducer: (state: ITechnologyToolState, action: PayloadAction<ISetError>) => {
                return {
                    technologyTools: state.technologyTools,
                    isLoading: state.isLoading,
                    isInitialized: state.isInitialized,
                    error: action.payload.error,
                };
            },
            prepare(error: string | null) {
                return {
                    payload: {error: error},
                };
            },
        },
        fetchTechnologyTools: (state: ITechnologyToolState) => {
            return {
                ...state,
                isLoading: true,
            };
        },
    },
});

export const {
    changeTechnologyTool,
    changeIsTechnologyToolLoading,
    changeIsTechnologyToolInitialized,
    setTechnologyToolError,
    fetchTechnologyTools,
} = technologyToolSlice.actions;

export default technologyToolSlice.reducer;
